/**
 * ghepMenu — GHÉP menu cấu hình sẵn của giao diện (`config.modules`) với các nhóm menu máy chủ trả về
 * (`moduleinfo`, gồm nhóm của usermodule do hook core.onMenu chèn).
 *
 * Tách khỏi APIs.asyncGetModules thành hàm THUẦN (không import gì) để test node chạy thẳng mã này.
 *
 * Quy tắc (giữ nguyên như trước):
 *   - Nhóm menu GỐC (không mother_module): trùng mã với nhóm cấu hình -> mục mới nối vào, nhóm con = tiêu đề
 *     nhóm máy chủ; không trùng -> thêm thành nhóm menu riêng.
 *   - Nhóm CON (có mother_module): mục nối vào nhóm cha, nhóm con = tiêu đề bản ghi. Mục TRÙNG MÃ với mục có
 *     sẵn của nhóm cha bị bỏ qua.
 * Bổ sung:
 *   - Mục `ghi_de: true` (module XẾP LẠI mục lõi): không thêm mới mà ĐỔI nhóm con (và tên nếu có) của mục cùng mã
 *     sẵn có — giữ đường dẫn, quyền, loại của lõi. Nhóm cha không có mục đó: có `path` thì thêm như mục thường,
 *     không có thì bỏ (không sinh mục chết). Kèm `visible: false` = module đã thay mục đó bằng màn hình của nó
 *     -> ẩn mục lõi (không bao giờ thêm mới một mục ẩn).
 *   - Bản ghi có `sap_xep_nhom` (số): mục của nó được XẾP TRƯỚC, theo (sap_xep_nhom, thứ tự trong bản ghi); mục
 *     lõi không ai xếp giữ thứ tự cũ, nằm sau. Nhóm cha không có bản ghi nào như vậy -> thứ tự như trước.
 *
 * @param {Array} modules       menu cấu hình (đã clone, code đã chữ thường) — BỊ SỬA tại chỗ
 * @param {Array} extraModules  bản ghi moduleinfo từ máy chủ (đã sort theo stt)
 * @returns {Array} modules
 */
export function ghepMenu(modules, extraModules) {
  const ds = Array.isArray(extraModules) ? extraModules : [];
  const chuanHoa = (m) => {
    m.code = (m.code || m.title || "").toLowerCase();
    m.items = (m.items || []).filter((i) => i && i.code);
  };
  const cungMa = (a, b) => (a.code || "").toUpperCase() === (b.code || "").toUpperCase();

  ds.filter((m) => !m.mother_module || m.mother_module === "--").forEach((extra) => {
    chuanHoa(extra);
    const conf = modules.find((m) => m.code === extra.code);
    if (!conf) { modules.push(extra); return; }
    conf.items = conf.items || [];
    extra.items.forEach((item) => {
      if (item.ghi_de) return; // mục lõi chỉ có nghĩa trong nhóm con của nhóm cha
      if (!conf.items.find((c) => cungMa(c, item))) {
        item.group = extra.title;
        conf.items.push(item);
      }
    });
  });

  const daXep = new Set();
  ds.filter((m) => m.mother_module && m.mother_module !== "--").forEach((extra) => {
    chuanHoa(extra);
    const conf = modules.find((m) => m.code === extra.mother_module.toLowerCase());
    if (!conf) {
      // Không có nhóm cha (bộ menu khác): đứng riêng; mục lõi không có đường dẫn thì bỏ.
      extra.items = extra.items.filter((i) => !i.ghi_de || (i.path && i.visible !== false));
      extra.items.forEach((i) => { delete i.ghi_de; });
      if (extra.items.length) modules.push(extra);
      return;
    }
    conf.items = conf.items || [];
    const xep = typeof extra.sap_xep_nhom === "number" && isFinite(extra.sap_xep_nhom);
    if (xep) daXep.add(conf);
    extra.items.forEach((item, idx) => {
      const hang = xep ? extra.sap_xep_nhom * 100000 + idx : undefined;
      const san = conf.items.find((c) => cungMa(c, item));
      if (item.ghi_de) {
        if (san) {
          if (item.visible === false) { san.visible = false; return; }
          san.group = extra.title;
          if (item.title) san.title = item.title;
          if (item.icon) san.icon = item.icon;
          if (hang !== undefined) san._hang_menu = hang;
          return;
        }
        if (!item.path || item.visible === false) return;
        delete item.ghi_de;
      } else if (san) {
        return;
      }
      item.group = extra.title;
      if (hang !== undefined) item._hang_menu = hang;
      conf.items.push(item);
    });
  });

  daXep.forEach((conf) => {
    const coHang = conf.items.filter((i) => i._hang_menu !== undefined).sort((a, b) => a._hang_menu - b._hang_menu);
    const conLai = conf.items.filter((i) => i._hang_menu === undefined);
    conf.items = coHang.concat(conLai);
  });
  modules.forEach((m) => (m.items || []).forEach((i) => { delete i._hang_menu; }));
  return modules;
}

export default ghepMenu;
